import React, {useMemo} from 'react';
import LogTemplate from "./LogTemplate";
import GoToUserInfoButton from "../../shared/components/buttons/GoToUserInfoButton";
import {DEFAULT_LOG_SEARCH_PARAM} from "../../shared/utils/basic";
import {getLoginLogColumns} from "./columns/loginLogColumns";

const LoginLog = () => {
    const columns = useMemo(() => ([
        {
            title: 'PID',
            dataIndex: 'pid',
            search: true,
        },
        {
            title: '유저 이름',
            dataIndex: 'name',
            search: true,
        },
        ...getLoginLogColumns(),
        {
            title: '유저 정보',
            dataIndex: 'pid',
            render: (pid) => <GoToUserInfoButton pid={pid} />,
        },
    ]), []);

    const searchParams = useMemo(() => ({
        ...DEFAULT_LOG_SEARCH_PARAM,
        logType: 'login_log',
        isUnix: true,
    }), []);

    return (
        <LogTemplate
            columns={columns}
            defaultSearchParams={searchParams}
            routerUrl={'/logs'}
            logName={'LoginLog'}
        />
    );
};

export default LoginLog;